export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-light-92d0fff2407e41ca523cb6a06d572057.ttf";